import Papa from 'papaparse'

export const makeCSV = (textfile) =>
  new Promise((resolve, reject) => {
    Papa.parse(textfile, {
      error: (e) => reject(e),
      complete: (f) => resolve(f.data),
    })
  })
